import Joi from 'joi-browser';
import { EXISTANCE_EXCLUSION_FLAG } from '../../utilities/constants';

/**
 * 安全書類項目で未入力のものを確認する用
 * エラーメッセージの表示順序をフォームの表示順番と揃える必要があるため
 * バリデーションの順番はフォームの順番と揃える
 */
export const schemaForSafetyDoc = () => {
  const validateSchema = Object.create(null);

  // 建物名・部屋番号等
  validateSchema.building_name = Joi.string().required();

  const companyDetail = {
    company_detail: Joi.object().keys({
      construction_industry_permission_flag: Joi.number().required(),
    }),
  };

  /**
   *  元請用_健康保険情報 安全書類項目の入力判定
   *   例外:適用除外理由「５人未満個人事業所」+ 保険種類「国民健康保険」の場合は安全書類項目ラベルが表示されないので対象外
   */
  const primeHealthInsuranceSafetyDocItem = Joi.when('health_insurance_flag', {
    is: EXISTANCE_EXCLUSION_FLAG.EXIST.ID,
    then: Joi.string().required(),
  }).when('health_insurance_flag', {
    is: EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID,
    then: Joi.when('health_insurance_reason_exclusion', {
      is: Joi.string().invalid(['５人未満個人事業所', 'けんぽ適用除外承認済']),
      then: Joi.string().required(),
    })
      .when('health_insurance_reason_exclusion', {
        is: Joi.string().valid(['', null]),
        then: Joi.string().required(),
      })
      .when('health_insurance_reason_exclusion', {
        is: '５人未満個人事業所',
        then: Joi.when('health_insurance_type', {
          is: Joi.string().invalid('国民健康保険'),
          then: Joi.string().required(),
        }).when('health_insurance_type', {
          is: Joi.string().valid(['', null]),
          then: Joi.string().required(),
        }),
      })
      .when('health_insurance_reason_exclusion', {
        is: 'けんぽ適用除外承認済',
        then: Joi.string().required(),
      }),
  });

  const companyBranchInsurance = () => {
    const health = () => {
      const required = {
        health_insurance_flag: Joi.string().required(), // 健康保険_加入状況
        health_insurance_name_insurer: primeHealthInsuranceSafetyDocItem, // 健康保険_健康保険者名称
        health_insurance_office_symbol: primeHealthInsuranceSafetyDocItem, // 健康保険_事業所整理記号
        health_insurance_office_number: primeHealthInsuranceSafetyDocItem, // 健康保険_事業所整理番号
      };
      return required;
    };

    const pension = () => {
      const required = {
        pension_flag: Joi.string().required(), // 年金保険_加入状況
        pension_office_symbol: Joi.when('pension_flag', {
          is: EXISTANCE_EXCLUSION_FLAG.EXIST.ID,
          then: Joi.string().required(), // 年金保険_事業所整理記号,
        }),
        pension_office_number: Joi.when('pension_flag', {
          is: EXISTANCE_EXCLUSION_FLAG.EXIST.ID,
          then: Joi.string().required(), // 年金保険_事業所番号,
        }),
      };
      return required;
    };
    const employment = () => {
      const required = {
        employment_insurance_flag: Joi.string().required(), // 雇用保険_加入状況
        employment_insurance_insurance_number: Joi.when(
          'employment_insurance_flag',
          {
            is: EXISTANCE_EXCLUSION_FLAG.EXIST.ID,
            then: Joi.string().required(), // 雇用保険_労働保険番号
          }
        ),
      };
      return required;
    };

    return {
      company_branch_insurance: Joi.object().keys({
        ...health(),
        ...pension(),
        ...employment(),
      }),
    };
  };

  return Object.assign(validateSchema, companyDetail, companyBranchInsurance());
};



// WEBPACK FOOTER //
// ./src/utilities/validationSchemas/primeCompanyEdit.js